import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Showcasing model vehicles and collectibles for enthusiasts and collectors" 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">DMV Models · Your Destination for Collectibles</p>
        <h1>Discover the World of Model Vehicles</h1>
        <p className="lede">
          At DMV Models, we bring together enthusiasts and collectors with a curated selection of model vehicles and collectibles. Explore our diverse range and find your next prized possession.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_self">
            Shop Now
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Explore Our Collection</h2>
          <p>
            From classic cars to modern marvels, our extensive inventory caters to every collector's passion.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Connect with fellow enthusiasts, share your collection, and stay updated on the latest trends in the model vehicle world.
          </p>
        </article>
        <article>
          <h2>Stay Informed</h2>
          <p>
            Subscribe to our newsletter for exclusive updates, new arrivals, and special events tailored for collectors like you.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;